import { render, staticRenderFns } from "./GptPanel.vue?vue&type=template&id=057ba26a&"
import script from "./GptPanel.vue?vue&type=script&lang=js&"
export * from "./GptPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports